import { useState } from 'react';
import { useApp } from './context';
import { Dismiss, Modal } from './ui';
import { errorMessage } from '../data/repo';

const DRAFT_KEY = 'financeCockpitCaptureDraft';
const readDraft = () => { try { return sessionStorage.getItem(DRAFT_KEY) ?? ''; } catch { return ''; } };
const writeDraft = (v: string) => { try { v ? sessionStorage.setItem(DRAFT_KEY, v) : sessionStorage.removeItem(DRAFT_KEY); } catch { /* ignore */ } };

/** For unusual off-bank events only: cash, reimbursements, business costs paid personally. */
export function QuickCapture({ onClose }: { onClose: () => void }) {
  const { repo } = useApp();
  const [text, setText] = useState(readDraft);
  const [status, setStatus] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);

  async function save() {
    setStatus(null);
    try {
      await repo.addQuickCapture(text.trim());
      writeDraft('');
      setSaved(true);
      setStatus('Saved. It will be matched during Close Month.');
      setText('');
    } catch (e) {
      setStatus(errorMessage(e));
    }
  }

  return (
    <Modal title="Record something unusual" kicker="Quick Capture" onClose={onClose}
      footer={<>
        <Dismiss>{saved ? 'Done' : 'Cancel'}</Dismiss>
        <button className="cta" disabled={!text.trim()} onClick={() => void save()}>Save</button>
      </>}>
      <p className="muted">Only for things your bank statements will not show correctly: cash, off-bank FX, reimbursements, business costs paid personally.</p>
      <textarea rows={3} value={text} placeholder="e.g. Cash gift to a friend, 150k"
        onChange={(e) => { setText(e.target.value); writeDraft(e.target.value); }} />
      {status && <p className="status-line" role="status">{status}</p>}
    </Modal>
  );
}
